import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Landing page entry point for marketing traffic (Instagram/ad campaigns/reels).
 * Clears any stale state and redirects to the exact same onboarding flow
 * used in the app: SmartNotebookInput → LoadingStoryGenerator → PastStoryRevolutionary
 * 
 * No login required. Passes ?source=landing|watch through the flow so the
 * story page shows a download CTA instead of redirecting to login.
 * 
 * Used for both /past-story-landing and /watch routes.
 */
const PastStoryLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Clear previous story state so user gets a fresh experience
    localStorage.removeItem('past_story_viewed');
    localStorage.removeItem('free_story_used');
    localStorage.removeItem('watching_story');
    localStorage.removeItem('onboarding_completed');
    localStorage.removeItem('story_generated');
    localStorage.removeItem('story_generation_in_progress');
    localStorage.removeItem('ps_selected_language');
    localStorage.removeItem('onboarding_form_draft');
    localStorage.removeItem('onboarding_in_progress');

    // Detect source based on path: /watch → source=watch, else source=landing
    const source = location.pathname === '/watch' ? 'watch' : 'landing';
    navigate(`/onboarding-new?source=${source}`, { replace: true });
  }, [navigate, location.pathname]);

  return null;
};

export default PastStoryLanding;
